
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';

export const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(0);

    const faqData = [
        { question: 'How does Coleese prevent rental scams?', answer: 'We take safety seriously. Every host and tenant undergoes mandatory biometric identity verification, and we verify property ownership deeds before a listing goes live. You can book viewings and sign leases with total peace of mind.' },
        { question: 'Is it free to join?', answer: 'Yes! It is completely free for tenants to search, view properties, and apply. Hosts can list properties for free and only pay a small service fee once a lease is successfully signed.' },
        { question: 'Are the digital leases legally binding?', answer: 'Absolutely. Our smart contracts are drafted by top legal experts to be fully compliant with South African rental housing laws. Once signed digitally by all parties, they are as legally binding as pen-and-paper agreements.' },
        { question: 'Can I split rent with my roommates?', answer: 'Yes, our built-in payment system handles rent splitting automatically. Each tenant pays their share directly through the app, and the host receives one consolidated payment. No more chasing roommates for money.' },
        { question: 'Is my personal data safe?', answer: 'Your privacy is our priority. We use bank-grade encryption to protect your sensitive data. Personal details like ID numbers and financial records are only shared securely when necessary for lease agreements.' },
    ];

    const handleAccordionClick = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionVariants = {
        hidden: { opacity: 0, height: 0 },
        visible: { opacity: 1, height: 'auto' },
        exit: { opacity: 0, height: 0 },
    };

    return (
        <section className="py-16 sm:py-24 bg-white">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto px-6">
                    <h2 className="text-2xl lg:text-3xl font-semibold tracking-tight">Have Any Questions?</h2>
                    <p className="mt-4 text-sm lg:text-md text-gray-600">Got questions? We're here for you, no matter where you are, ready to provide support and answers anytime.</p>
                </div>
                <div className="mt-16 max-w-3xl mx-auto space-y-4">
                    {faqData.map((item, index) => (
                        <div key={index} className="bg-white rounded-2xl shadow-lg shadow-gray-200/50">
                            <button onClick={() => handleAccordionClick(index)} className="w-full flex justify-between items-center p-6 text-left">
                                <h4 className="text-md font-semibold">{item.question}</h4>
                                <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-colors duration-300 ${activeIndex === index ? 'bg-black text-white' : 'bg-gray-100 text-black'}`}>
                                    {activeIndex === index ? <Minus size={16} /> : <Plus size={16} />}
                                </div>
                            </button>
                            <AnimatePresence>
                                {activeIndex === index && (
                                <motion.div
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={accordionVariants}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="px-6 pb-6 text-sm text-gray-600 leading-relaxed">{item.answer}</p>
                                </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
